import { ATTENTION_AVERAGE_WINDOW, ATTENTION_CONSECUTIVE_MISSES } from "@/constants/attention"
import type { AttentionReason } from "@/types"

/**
 * The N an attention reason names ("sus últimas 2 tareas", "sus últimas 5
 * calificaciones"): the payload's `attention_n` — the backend's own rule —
 * and the mirrored constants only when a payload predates that field.
 */
export const attentionCount = (reason: AttentionReason, n: number | null | undefined): number =>
  n ?? (reason === "missed_deliveries" ? ATTENTION_CONSECUTIVE_MISSES : ATTENTION_AVERAGE_WINDOW)
